<template>
	<span ref="number">{{ displayNumber }}</span>
</template>

<script>
export default {
props: ['number', 'separator', 'ready', 'speed', 'divisor', 'unit'],
data() {
	return {
			finalInteger: 0,
			currentInteger: 0,
			displayNumber: ' ',
			interval: false,
			animated: true
		}
	},
	computed: {
		finalSpeed() {
			return this.speed || 20
		},
		finalDivisor() {
			if (typeof this.divisor !== 'undefined') return this.divisor;
			return (this.finalInteger!==0 && this.finalInteger>10000) ? 2 : 5;
		},
		finalUnit() {
			return this.unit || ''
		}
	},
	methods: {
		setupFormatting() {
			
			this.finalInteger = (!this.separator) ? this.number : this.number.replace(this.separator, '')

		},
		numberWithSeparator(number) {
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
		},
		formatNumber(number) {
			return ((!this.separator) ? number : this.numberWithSeparator(number)) + this.finalUnit
		},
		animateNumber() {	
			clearInterval(this.interval);
			if(this.currentInteger >= this.finalInteger){
				return;
			}
			this.interval = window.setInterval(function(){
				if(this.currentInteger != this.finalInteger){
					var change = (this.finalInteger - this.currentInteger) / this.finalDivisor;
					change = change >= 0 ? Math.ceil(change) : Math.floor(change);
					this.currentInteger = this.currentInteger + change;
					this.displayNumber = this.formatNumber(this.currentInteger)
				} else {
					this.displayNumber = this.formatNumber(this.number) + this.finalUnit
				}
			}.bind(this), this.finalSpeed);
		}
	},
	watch: {
		ready(newVal) {
			if (newVal) {
				this.ready = true;
				setTimeout(() => { this.animateNumber(); }, 400);	
			}
		},
	
	},
	mounted() {
		this.setupFormatting()
		if (this.ready) {
			setTimeout(() => { this.animateNumber(); }, 400);	
		}
	}
}
</script>